import SourceFlowApplicationForm from "@sourceflow-uk/sourceflowapplicationform";
import useLocale from "@/hooks/useLocale";
import localizePath from "@/functions/localizePath";

export default function JobPageDescription({ job }) {
  const locale = useLocale();

  const onSubmitDone = () => {
    window.location.href = localizePath("/jobs/thank-you-for-applying", locale);
  };

  return (
    <div className="job-description">
      <div>
        <div className="text-purple text-base md:text-xl/[34px] whitespace-pre-line">
          {job?.description && (
            <span dangerouslySetInnerHTML={{ __html: job?.description }} />
          )}
        </div>
        <div className="mt-10" id="job-form">
          <div className="bg-purple p-5 text-base md:text-xl/[34px] whitespace-pre-lin job-application-form mt-10">
            <SourceFlowApplicationForm
              onSubmitDone={onSubmitDone}
              jobId={job?.id}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
